import React,{useEffect, useRef, useState} from 'react'
import { Helmet } from "react-helmet";


import TopBarOffer from './TopBarOffer'
import TopHeaderComponent from './TopHeaderComponent'
import FemaleServicesComponent from './FemaleServicesComponent'
import LandingNavbar from '../../components/user/LandingNavbar'
import FaqComponentFemale from './FaqComponentFemale'
import WhyUsFemale from './WhyUsFemale'
import  FooterFemalePage from "./FooterFemalePage"
import LandingNavFemale from './LandingNavFemale'
import TestimonialsFemalePage from './TestimonialsFemalePage'
import ContactButtonsFemalePage from './ContactButtonsFemalePage';
import NavTop2Component from '../../components/user/NavTop2Component';
import NumberIncrementComponent from '../../components/user/NumberIncrementComponent';
import CustomerFeedback from '../service/CustomerFeedback';
import CustomerFeedbackOnlyForFemale from './CustomerFeedbackOnlyForFemale';
import PopupNumber from '../../components/user/popUp/PopupNumber';
import FemalePopupNumber from './FemalePopupNumber';
import FemaleLandingPageVideoComponent from './FemaleLandingPageVideoComponent';


function LandingPageFemale() {


    // useEffect(() => {
    //   const hash = window.location.hash;
    //   if (hash) {
    //     const element = document.querySelector(hash);
    //     if (element) {
    //       element.scrollIntoView({ behavior: "smooth" });
    //     }
    //   }
    // }, []);



    useEffect(() => {
  const hash = decodeURIComponent(window.location.hash.substring(1));

  if (hash) {
    const element = document.getElementById(hash);

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
}, []);






const [popupOffer, setPopupOffer] = useState(false)


  
  
    // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  
      const timeoutRef = useRef(null);
      const showAlert = () => {
        setPopupOffer(true);
      };
    



      
      const resetTimer = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(showAlert, 20000);
      };
    
      useEffect(() => {
        const events = ['click', 'scroll', 'mousemove', 'keydown'];
        events.forEach(event =>
          window.addEventListener(event, resetTimer)
        );
    
        resetTimer();
        return () => {
          events.forEach(event =>
            window.removeEventListener(event, resetTimer)
          );
          clearTimeout(timeoutRef.current);
        };
      }, []);
    

















  return (
<>

      <div className="landing-page landing-page-ncr">

<Helmet>
  <title>Glazma Women Salon at Home in Delhi NCR</title>

  <meta property="og:title" content="Glazma Women Salon at Home in Delhi NCR" />
  <meta
    property="og:description"
    content="Book professional women salon services at home in Delhi NCR. Facial, waxing, beauty services by certified experts."
  />
  <meta
    property="og:url"
    content="https://glazma.com/salon-for-women-at-home"
  />
  <meta property="og:type" content="website" />
</Helmet>







   <div className="landing-page-navbar">

          <NavTop2Component/>

 <LandingNavFemale/>


   </div>
<TopHeaderComponent/>

 <NumberIncrementComponent/>
 <FemaleLandingPageVideoComponent/>

<FemaleServicesComponent/>

<div>

  <WhyUsFemale/>
</div>


    {
popupOffer?
      <FemalePopupNumber open={setPopupOffer}/>
      :""
      } 
      
<div>


    <CustomerFeedbackOnlyForFemale/>

</div>

<div>
  <FaqComponentFemale/>


  

</div>

<FooterFemalePage/>

<div>

  {/* <ContactButtonsFemalePage/> */}
</div>
</div>
</>
  )
}

export default LandingPageFemale